import {
  CREATE_LIST_SIGN_METHOD,
  CREATE_LIST_SIGN_METHOD_FAIL,
  CREATE_LIST_SIGN_METHOD_SUCCESS,
  CREATE_SIGN_METHOD,
  CREATE_SIGN_METHOD_FAIL,
  CREATE_SIGN_METHOD_SUCCESS,
  DELETE_SIGN_METHOD,
  DELETE_SIGN_METHOD_FAIL,
  DELETE_SIGN_METHOD_SUCCESS,
  EDIT_SIGN_METHOD,
  EDIT_SIGN_METHOD_FAIL,
  EDIT_SIGN_METHOD_SUCCESS,
  GET_ALL_SIGN_METHOD,
  GET_ALL_SIGN_METHOD_FAIL,
  GET_ALL_SIGN_METHOD_SUCCESS,
  GET_DETAIL_SIGN_METHOD,
  GET_DETAIL_SIGN_METHOD_FAIL,
  GET_DETAIL_SIGN_METHOD_SUCCESS,
  GET_LIST_SIGN_METHOD,
  GET_LIST_SIGN_METHOD_FAIL,
  GET_LIST_SIGN_METHOD_SUCCESS,
  GET_LIST_VAT,
  GET_LIST_VAT_FAIL,
  GET_LIST_VAT_SUCCESS,
  RESET_CREATE_LIST_SIGN_METHOD,
  RESET_CREATE_SIGN_METHOD,
  RESET_DELETE_SIGN_METHOD,
  RESET_EDIT_SIGN_METHOD,
  RESET_LIST_SIGN_METHOD,
  SET_COLUMN_VISIBLE_SIGN_METHOD,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  // sign method
  signMethod: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  detailSignMethod: {
    loading: false,
    data: null,
    error: null,
  },
  createSignMethod: {
    loading: false,
    data: null,
    error: null,
  },
  createListSignMethod: {
    loading: false,
    data: null,
    error: null,
  },
  editSignMethod: {
    loading: false,
    data: null,
    error: null,
  },
  deleteSignMethod: {
    loading: false,
    data: null,
    error: null,
  },
  listVat: [],
  listAllSignMethod: [],
};

const signMethod = (state = INIT_STATE, action) => {
  const curSignMethod = state.signMethod;
  switch (action.type) {
    // sign method
    case GET_LIST_SIGN_METHOD:
      return {
        ...state,
        signMethod: {
          ...curSignMethod,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_SIGN_METHOD_SUCCESS:
      return {
        ...state,
        signMethod: {
          ...curSignMethod,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_SIGN_METHOD_FAIL:
      return {
        ...state,
        signMethod: {
          ...curSignMethod,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_SIGN_METHOD:
      return {
        ...state,
        signMethod: {
          ...curSignMethod,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Detail sign method
    case GET_DETAIL_SIGN_METHOD:
      return {
        ...state,
        detailSignMethod: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DETAIL_SIGN_METHOD_SUCCESS:
      return {
        ...state,
        detailSignMethod: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_DETAIL_SIGN_METHOD_FAIL:
      return {
        ...state,
        detailSignMethod: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    // Tạo sản phẩm dịch vụ
    case CREATE_SIGN_METHOD:
      return {
        ...state,
        createSignMethod: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_SIGN_METHOD_SUCCESS:
      return {
        ...state,
        createSignMethod: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_SIGN_METHOD_FAIL:
      return {
        ...state,
        createSignMethod: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_SIGN_METHOD:
      return {
        ...state,
        createSignMethod: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Tạo list sản phẩm dịch vụ
    case CREATE_LIST_SIGN_METHOD:
      return {
        ...state,
        createListSignMethod: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_LIST_SIGN_METHOD_SUCCESS:
      return {
        ...state,
        createListSignMethod: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_LIST_SIGN_METHOD_FAIL:
      return {
        ...state,
        createListSignMethod: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_LIST_SIGN_METHOD:
      return {
        ...state,
        createListSignMethod: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Cập nhật sản phẩm dịch vụ
    case EDIT_SIGN_METHOD:
      return {
        ...state,
        editSignMethod: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case EDIT_SIGN_METHOD_SUCCESS:
      return {
        ...state,
        editSignMethod: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case EDIT_SIGN_METHOD_FAIL:
      return {
        ...state,
        editSignMethod: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_EDIT_SIGN_METHOD:
      return {
        ...state,
        editSignMethod: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xóa sản phẩm dịch vụ
    case DELETE_SIGN_METHOD:
      return {
        ...state,
        deleteSignMethod: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case DELETE_SIGN_METHOD_SUCCESS:
      return {
        ...state,
        deleteSignMethod: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case DELETE_SIGN_METHOD_FAIL:
      return {
        ...state,
        deleteSignMethod: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_DELETE_SIGN_METHOD:
      return {
        ...state,
        deleteSignMethod: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Get list Vat
    case GET_LIST_VAT:
      return {
        ...state,
        listVat: [],
      };
    case GET_LIST_VAT_SUCCESS:
      return {
        ...state,
        listVat: action.data,
      };

    case GET_LIST_VAT_FAIL:
      return {
        ...state,
        listVat: [],
      };
    // GET_ALL_SIGN_METHOD
    case GET_ALL_SIGN_METHOD:
      return {
        ...state,
        listAllSignMethod: [],
      };
    case GET_ALL_SIGN_METHOD_SUCCESS:
      return {
        ...state,
        listAllSignMethod: action.data,
      };

    case GET_ALL_SIGN_METHOD_FAIL:
      return {
        ...state,
        listAllSignMethod: [],
      };
    // Set column
    case SET_COLUMN_VISIBLE_SIGN_METHOD:
      curSignMethod.columnsVisible[action.field] = action.value;
      return {
        ...state,
        signMethod: {
          ...curSignMethod,
        },
      };
    default:
      return state;
  }
};

export default signMethod;
